export const jsonParse = (value: any) => {
  try {
    return JSON.parse(value);
  } catch (_) {
    return value;
  }
};
